import React from 'react';
import styled from 'styled-components';
import Store from '../../Common/Store.js';
import {FaPlus} from 'react-icons/fa';
import CSLTable from '../Common/CSLTable';
import DatePicker from 'react-date-picker';
import APICall from '../../Common/APICall';
import TeamAskGiftsModal from './TeamAskGiftsModal';
import TeamApprovalGiftsModal from './TeamApprovalGiftsModal';
import {IoIosArrowDown, IoIosArrowUp} from 'react-icons/io';
import TeamFollowupModal from './TeamFollowupModal';
import AdvancedFilter from '../Filter/AdvancedFilter';
import CSLbucketloader from '../Common/CSLbucketloader';
import CSLLoader from '../Common/CSLLoader';
import AlertBox from '../Common/AlertBox'

import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import moment from 'moment';
import XcelLoader from './../../Common/XcelLoader';

const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const fileExtension = '.xlsx';

const MRTable = styled.table`
    table-layout: fixed;
    width: 100%;
    margin-top: 15px;
`;
const MRButton = styled.button`
    box-sizing: border-box;
    background-color: #37ada7;
    color: #ffffff;
    border: 1px solid #37ada7;
    width: 84px;
    font-size: 13px;
    height: 25px;
    border-radius: 4px;
`;
const HeaderText = styled.div`
    float: left;
    margin-left: 20px;
    margin-top: 10px;
    margin-bottom: 10px;
    color: #c0c0c0;
    font-weight: 600;
    letter-spacing: 1px;
`;
const TableHeaderIcon = styled.div`
    float: right;
    margin-right: 20px;
    margin-top: 15px;
    color: #c0c0c0;
`;

const TextPara = styled.div`
    padding: 15px 15px 15px 15px;
    color: #c0c0c0;
`;
const OverviewInfoHeader = styled.div`
    padding: 12px 15px;
    background-color: #ffffff;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;    
    width: 96%;
    margin: 0 auto;
    margin-top: 30px;    
`;
const OverviewInfoBody = styled.div`
	padding: 15px;
    background-color: #ffffff;
    border: 1px solid #d7dddf;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    width: 96%;
    margin: 0 auto;
    margin-bottom: 30px;
`;
const MRModalLabel = styled.div`
    color: #a0a0a0;
    font-weight: 600;
    margin-top: 10px;
    margin-bottom: 10px;
`;
const ConflictInput = styled.input`
    height: 30px;
    width: 100%;
    border: 1px solid #ffffff;
    border-radius: 3px;
    box-shadow: 0 0 4px #c4c4c4;
    padding: 5px;
    color: black;
`;
const ConflictSelect = styled.select`
    display: block;
    box-sizing: border-box;
    height: 40px;
    width: 100%;
    background-color: #fff;
    border: 1px solid #ffffff;
    border-radius: 3px;
    box-shadow: 0 0 4px #c4c4c4;
    font-family: Montserrat,sans-serif;
    color: #414141;
`;
const CSLDateCover = styled.div`
    height: 30px;
    width: 20%;
    border: 1px solid #ffffff;
    border-radius: 3px;
    box-shadow: 0 0 4px #c4c4c4;
    padding: 5px;
    color: #979797;
`;
const RegModalIssueDateLabel = styled.label`
    font-weight: 600;
    color: #979797;
    margin-bottom: 10px;
`;
const RegCancelButton = styled.button`
    display: inline-block;
    box-sizing: border-box;
    background-color: #ffffff;
    color: #909090;
    border: 2px solid #dadada;
    width: 100px;
    height: 35px;
    border-radius: 4px;
    font-size: 11px;
    cursor: pointer;
`;
const RegSubmitButton = styled.button`
    display: inline-block;
    box-sizing: border-box;
    background-color: #37ada7;
    color: #ffffff;
    width: 100px;
    height: 35px;
    border-radius: 4px;
    border: 1px solid #37ada7;
    margin-left: 5px;
    font-size: 11px;
    cursor: pointer;
`;
const FooterButtonsContainer = styled.div`
	text-align: right;
	padding-top: 25px;
	width: 70%;
`;
const ExportButton = styled.button`
    box-sizing: border-box;
    background-color: #213E61;
    color: #F2F2F2;
    border: 1px solid #213E61;
    width: 125px;
    font-size: 14px;
    height: 32px;
    border-radius: 5px;
    margin-right: 3px;
    margin-top: 19px;
    cursor: pointer;
`;

const BoxStyle = styled.div`
  float: left;
  width: 15px;
  height: 15px;
  margin: 2px;
  border: 1px solid rgba(0, 0, 0, .2);
  margin-right: 10px;
`;

const InactiveOverlay = styled.div`
  display: block;
  box-sizing: border-box;
  height: 150%;
  width: 100%;
  background-color: #ffffff;
  position: absolute;
  left: -2%;
  top: -46px;
  z-index: 1000;
  opacity: 0.8;
`;

class GiftsList extends React.Component
{
    state = {
        isLoaded: false,
        pending_tasks: [],
        advanceFilter: false,
        show_modal: null,
        conflictFilterUser: "0",
        conflictFilterType: "",
        conflictFilterStatus: "",
        filterRequestedFromDate: new Date(),
        filterRequestedToDate: new Date(),
        ready: false,
        giftsTaskList: null,
        giftsTaskListFilter: null,
        followUp: null,
        giftTypeList: [],
        view_count: 0,
        isLoadedIcon: false,
        alert_param: null
    };
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        let followupTask = Store.getStoreData('followup_tasks');
        let followup = {};
        for(let d of followupTask){
        //for(let i=0;i<followupTask.length;i++){
            followup[d[3]] = d[4];
        }
        let myGiftsTask = Store.getStoreData('myinitiatedtasks');
        let updateFromDate = new Date(this.state.filterRequestedFromDate.getFullYear(), this.state.filterRequestedFromDate.getMonth() - 1, 1);

        let giftTypeList = [];
        if('gift_types' in Store.getStoreData('module_config')){
            giftTypeList = Store.getStoreData('module_config').gift_types;
        }

        let task_id = this.props.taskId;
        console.log("task_id3===>",task_id)
        this.setState({ giftsTaskList: myGiftsTask,giftsTaskListFilter: myGiftsTask, filterRequestedFromDate: updateFromDate,followUp: followup,giftTypeList: giftTypeList})
        if(task_id > 0) {
            console.log("task id", task_id)
            this.goToTaskUrlBare(task_id)
        }else{
            this.setState({ready: true})
        }
    }

    componentDidUpdate(prevprops) {
        if(this.props === prevprops)return
            let followupTask = Store.getStoreData('followup_tasks');
            let followup = {};
            for(let d of followupTask){
            //for(let i=0;i<followupTask.length;i++){
                followup[d[3]] = d[4];
            }
            let myGiftsTask = Store.getStoreData('myinitiatedtasks');
        this.setState({ giftsTaskList: myGiftsTask,giftsTaskListFilter: myGiftsTask, followUp: followup, ready: true })
    }

    goToTaskUrlBare = (taskID) => {
        let postData = { "command" : "getTaskCallbyTaskID", "task_id" : taskID }
        postData['gcs'] = Store.getStoreData('gc_filters');
        let api = new APICall();
        api.command(postData, this.processGiftsTaskAPIData);
    }

    processGiftsTaskAPIData = (result) => {
        console.log(result);
        if(result.error_code > 0) {
            // alert(msg)
            let msg = result.error_msg;
            let title = 'Alert'
            let alert_param = {title: title, message: msg, ok_text: 'OK', confirm: false, alertHandler: this.samealertremoveHandler, stack: {id: 0}}
            this.setState({alert_param: alert_param})
            return false;
          }
        let cur_lane = result.result.parenttask.cur_lane;
        let parentID = result.result.parenttask.id;
        if(cur_lane === 'COMP_GIFTS_FOLLOWUP_ASSIGNMENT' || cur_lane === 'COMP_GIFTS_FOLLOWUP_COMPLETE'){
            this.showFollowUpTaskApi(parentID);
        }else{
            this.processGiftsTaskData(result);
        }
    }

    samealertremoveHandler = (result,stack) => {
        this.setState({alert_param: null})
    }

    showFollowUpTaskApi = (task_id) => {
        //event.preventDefault();
        console.log('ROWS', task_id);
        let postData = { command: "GetSubTaskCallbyTaskID", task_id: task_id};
        postData['gcs'] = Store.getStoreData('gc_filters');
        let api = new APICall();
        api.command(postData, this.openFollowupModalTaskApi);
    }
    openFollowupModalTaskApi = (result) => {
        console.log(result);
        if(result.error_code > 0) {
            let msg = result.error_msg;
            let title = 'Alert'
            let alert_param = {title: title, message: msg, ok_text: 'OK', confirm: false, alertHandler: this.samealertremoveHandler, stack: {id: 0}}
            this.setState({alert_param: alert_param})
            // alert(msg)
            return false;
          }
        Store.updateStore('followup_task', result.result.task);
        this.setState({showModal: 'view_followup_modal',ready: true});
    }

    goToTaskUrl = (row) => (event) => {
        event.preventDefault();
        console.log('ROWS', row);
        this.setState({isLoadedIcon:true})
        this.showGiftsRegisterModal(row);
    }

    showGiftsRegisterModal = (row) => {
        //event.preventDefault();
        if(this.props.taskId > 0) {
            Store.updateStore('q_index', 1);
            let postData = { "command" : "get_task", "task_id" : row }
            let api = new APICall();
            api.command(postData, this.processGiftsTaskData);
        }else{
            //console.log('Rows', row);
            Store.updateStore('q_index', row.index);
            let postData = { "command" : "get_task", "task_id" : row.original.id }
            let api = new APICall();
            api.command(postData, this.processGiftsTaskDataWithApproval(row.original.isLM));
        }
    }
    processGiftsTaskData = (result) => {
        console.log('task result', result);
        Store.updateStore('cur_q_modal_data', result.result.parenttask);
        let contact_id = Store.getStoreData('contact_id');
        let isLM = result.result.manager_id !== null ? parseInt(result.result.manager_id) === parseInt(contact_id) ? true : false : false
        if(isLM){
            Store.updateStore('manager_id', result.result.manager_id);
            this.setState({showModal: "teamApprovalGiftsModal", ready: true, isLoadedIcon:false});
        }else{
            this.setState({showModal: "teamAskGiftsModal", ready: true, isLoadedIcon:false});
        }
        // this.setState({showModal: "teamAskGiftsModal", ready: true, isLoadedIcon:false});
    }
    processGiftsTaskDataWithApproval = (isLM) => (result) => {
        console.log('task result', result);
        Store.updateStore('cur_q_modal_data', result.result.parenttask);
        if(isLM){
            Store.updateStore('manager_id', result.result.manager_id);
            this.setState({showModal: "teamApprovalGiftsModal", ready: true, isLoadedIcon:false});
        }else{
            this.setState({showModal: "teamAskGiftsModal", ready: true, isLoadedIcon:false});
        }
    }

    showAskQuestionModal = () => {
        Store.updateStore('OverlayHeight', `${document.body.scrollHeight.toString()}px`);
        Store.updateStore('view','team_ask_modal');
        this.props.refreshCallback();
    }

    processMygiftsValue = () => {
        const has_gc = Store.getStoreData('has_gc');
        var mytaskdata = Store.getStoreData('myinitiatedtasks') === null ? [] : this.state.giftsTaskList;
        console.log("mytaskdata",mytaskdata)
        let ret = {data: [], columns: []};
        let i = 0;
        ret.columns =[
        {'Header' : 'Status', accessor: 'status', Cell: row => (
            <div>
                {
                    (() => {
                        if(row.original.status === "Approved"){
                            return( <div><BoxStyle style={{backgroundColor: "#04ADA8"}}/><div style={{padding: "1px"}}>{row.original.status}</div></div>)
                        }else{
                            return( <div><BoxStyle style={{backgroundColor: "#234162"}}/><div style={{padding: "1px"}}>{row.original.status}</div></div>)
                        }
                    })()
                }

                </div>
          ), width: 120, headerStyle: {textAlign: 'left'}},
        {'Header' : 'ID', accessor: 'giftid', Cell: row => (
            <div style={{textDecoration: "underline",color: "#00B5B2", cursor: 'pointer'}} onClick={this.goToTaskUrl(row)}>{row.original.giftid}</div>
          ), width: 100, headerStyle: {textAlign: 'left'}},
        {Header: 'Received/Given', accessor: 'receivedorgiven', minWidth: 150, headerStyle: {textAlign: 'left'}},
        {Header: 'Type', accessor: 'gifttype', minWidth: 150, headerStyle: {textAlign: 'left'}},
        {Header: 'Recipient', accessor: 'recipientname', minWidth: 180, headerStyle: {textAlign: 'left'}},
        {Header: 'Company', accessor: 'company_name', minWidth: 300, headerStyle: {textAlign: 'left'}, show: has_gc ? true : false},
        // {Header: 'Tasks', accessor: 'no_of_followup', minWidth: 80, headerStyle: {textAlign: 'left'}},
        {'Header' : 'Tasks', Cell: row => (
            <div style={{textDecoration: "underline",color: "#00B5B2"}} >{row.original.no_of_followup}</div>
          ), width: 70, headerStyle: {textAlign: 'center'},style: {textAlign: 'center'}},
        {Header: 'Value', accessor: 'value', minWidth: 70, headerStyle: {textAlign: 'center'},style: {textAlign: 'center'}, sortMethod: (a,b) => {return a - b}},
        {Header: 'Result', accessor: 'resultvalue', minWidth: 120, headerStyle: {textAlign: 'left'}},
        {Header: 'Gifted Date', accessor: 'gifted_date', minWidth: 100, headerStyle: {textAlign: 'center'},style: {textAlign: 'center'}},
        {Header: 'Added Date', accessor: 'discloserdate', minWidth: 100, headerStyle: {textAlign: 'center'},style: {textAlign: 'center'}},
        {Header: 'Reviewer', accessor: 'reviewerName', minWidth: 120, headerStyle: {textAlign: 'center'},style: {textAlign: 'center'}},
        {Header: 'Reviewed', accessor: 'reviewedDate', minWidth: 100, headerStyle: {textAlign: 'center'},style: {textAlign: 'center'}},
        {Header: 'Action', Cell: row => (
            <div>
                <MRButton style={{cursor: 'pointer'}} onClick={this.goToTaskUrl(row)}>View</MRButton>
            </div>
          ), width: 120, headerStyle: {textAlign: 'center',fontWeight: "600"}}];

        let gc_assoc = Store.getStoreData('gc_assoc');
        let gc_company = "";
        for(let d of mytaskdata) {
            i++;
            gc_company = parseInt(d[1]) < 100000 ? Store.getStoreData('gc_company')[0].company_name : gc_assoc[(parseInt(d[1])%100000).toString()];
            let status = "";
            let countFollowup = 0;
            if(d[0] in this.state.followUp){
                countFollowup = 1;
            }
            let resultvalue = "";
            //let task_json = JSON.parse(d.task_json);
            if(d[2] === "COMP_GIFTS_REGISTER") {
                //status =  "Registered";
                status =  "Requires Approval";
                resultvalue = "Undetermined";
            }else if(d[2] === "COMP_GIFTS_TEAMSAVE") {
                status = "Saved";
                resultvalue = "Undetermined";
            }else if(d[2] === "COMP_GIFTS_COMPLETE") {
                // status = "Confirmed";
                status = "Approved";
                resultvalue = "Accepted";
            }
            let ref_id = "";
            if(d[5] !== null) {
                ref_id = d[5];
            }

            let giftTypeName = "";
            let giftTypeID = d[6];
            this.state.giftTypeList.forEach((item) => {
                if (item.giftTypeID === giftTypeID) {
                    giftTypeName = item.giftTypeName;
                }
            });

            let approval_rejection_text = "";
            let approval_rejection_description = "";
            if(d[8] === 1){
                approval_rejection_text = d[9];
                approval_rejection_description = d[20];
            }
            if(d[10] === 1){
                approval_rejection_text = d[11];
                approval_rejection_description = d[21];
            }

            let nooffollowup = countFollowup < 10 ? "0"+countFollowup.toString() : countFollowup;

            let reviewerName = '-';
            let contracts = Store.getStoreData('contacts');
            if(d[22] !== 0 && d[22] in contracts){
                reviewerName = contracts[d[22]];
            }
            let reviewedDate = '-'
            if(d[2] === 'COMP_GIFTS_COMPLETE' || d[2] === 'COMP_GIFTS_REMOVE'){
                reviewedDate = moment.unix(d[23]).format('DD/MM/YYYY')
            }

            let recipientname = d[13];
            if(d[26] === 'Other'){
                recipientname = 'Other - '+d[13];
            }

            let elem = {
                    'id': d[0],
                    'status' : status,
                    'giftid' : ref_id,
                    'company_name' : gc_company,
                    'receivedorgiven' : d[12] === 'received' ? 'Received' : 'Given',
                    'gifttype' : giftTypeName,
                    'recipientname' : recipientname,
                    'no_of_followup' : nooffollowup,
                    'value' : d[14],
                    'resultvalue' : resultvalue,
                    'discloserdate' : moment.unix(d[17]).format('DD/MM/YYYY'),
                    'donor' : d[15],
                    'description' : d[16],
                    'approval_rejection_text': approval_rejection_text,
                    'approval_rejection_description': approval_rejection_description,
                    'gifted_date': d[18] !== '' ? moment.unix(d[18]).format('DD/MM/YYYY') : '-',
                    'additional_fields': d[19],
                    'reviewerName': reviewerName,
                    'reviewedDate': reviewedDate,
                    'isLM': d[24],
                    'addedBy': d[4],
                    'giftGivenTo': d[27]
                   };
            ret.data.push(elem);
            let sarr = [];
            ret.data.forEach((item) => {
                if (item.status === "Saved") {
                    sarr.push(item);
                }
            })
            ret.data.forEach((item) => {
                if (item.status === "Requires Approval") {
                    sarr.push(item);
                }
            })
            ret.data.forEach((item) => {
                // if (item.status === "Confirmed") {
                if (item.status === "Approved") {
                    sarr.push(item);
                }
            })
            ret.data = sarr;
        }
        Store.updateStore('table_cur_data', ret.data)
        //console.log('table_cur_data',ret.data)
        return ret;
    }

    advanceFiltershow = (val) => {
        //console.log("Sourav",abc)
        this.setState({advanceFilter: val})
    }
    closeModal = (event) => {
        //event.preventDefault();
        this.setState({
            showModal: null
        })
    }

      exportToExcel = () => {
        let wb = {SheetNames:[], Sheets:{}};
        let open_tasks = Store.getStoreData('table_cur_data') === null ? [] : Store.getStoreData('table_cur_data');
        wb.SheetNames.push("Gifts Register Team");
        wb.Sheets["Gifts Register Team"] = XLSX.utils.json_to_sheet(XcelLoader.gifts_export_tasks(open_tasks));
        const format = "DD-MM-YYYY HH:mm:ss"
        let tm = moment().format(format);
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], {type: fileType});
        FileSaver.saveAs(data, 'Gifts_Register' + '-' + tm + fileExtension);
    }


      handleChange = (evt) => {
        this.setState({[evt.target.name]: evt.target.value});
    }
    onRequestedFromDate = (date) => {
        this.setState({filterRequestedFromDate: date});
    }
    onRequestedToDate = (date) => {
        this.setState({filterRequestedToDate: date});
    }
    filterClear = () => {
        console.log("Sourav")
        let filterFromdate = new Date();
        let updateFromDate = new Date(filterFromdate.getFullYear(), filterFromdate.getMonth() - 1, 1);
        this.setState({ conflictFilterUser: "0",
            conflictFilterType: "",
            conflictFilterStatus: "",
            filterRequestedFromDate: updateFromDate,
            filterRequestedToDate: new Date()})
    }
    filterSubmit = (filtergiftList) => {

        this.setState({giftsTaskList: filtergiftList})

    }

    processMyfollowupValue = () => {
        var followup_tasks = Store.getStoreData('followup_tasks') === null ? [] : Store.getStoreData('followup_tasks');
        console.log("followup_tasks",followup_tasks)
        let ret = {data: [], columns: []};
        let i = 0;
        ret.columns =[
            {Header: 'Task', accessor: 'task', minWidth: 240, headerStyle: {textAlign: 'left'}},
            {Header: 'Assigned To', accessor: 'assigned_to', minWidth: 120, headerStyle: {textAlign: 'left'}},
            {Header: 'Status', accessor: 'status', width: 120, headerStyle: {textAlign: 'left'}, Cell: cellInfo => (<div><MRButton style={{cursor: 'default',backgroundColor: `${cellInfo.value.color}`}}>{cellInfo.value.text}</MRButton></div>)},
            {Header: 'Due Date', accessor: 'due_date', minWidth: 120, headerStyle: {textAlign: 'left'}},
            {'Header' : 'Action', Cell: row => (
               <div>
                   <MRButton style={{width: '100px',cursor: 'pointer'}}  onClick={this.goToFollowTaskUrl(row.original.id)}>View</MRButton>
               </div>
            ), headerStyle:{textAlign: 'left'}}];
        for(let d of followup_tasks) {
            i++;
            let today = moment().unix();
            let text = (d[5]+86400) > today ? 'Pending' : 'Overdue';
            let color = (d[5]+86400) > today ? '#2E8B57' : '#FF0000';
            let task = Store.getStoreData('contacts')[parseInt(d[6])] +" has been assigned a task titled "+ d[7];
            let elem = {'task' : task,
                        'assigned_to' : Store.getStoreData('contacts')[parseInt(d[6])],
                        'status' : {text: text, color: color},
                        'due_date' : moment.unix(d[5]).format('DD/MM/YYYY'),
                        'id' : d[0]
                   };
            ret.data.push(elem);
        }
        return ret;
    }

    goToFollowTaskUrl = (task_id) => (event) => {
        event.preventDefault();
        console.log('ROWS', task_id);
        this.setState({isLoadedIcon: true})
        this.showFollowUp(task_id);
    }

    showFollowUp = (task_id) => {
        //event.preventDefault();
        console.log('ROWS', task_id);
        let postData = { command: "get_subtask", task_id: task_id};
        let api = new APICall();
        api.command(postData, this.openFollowupModal);
    }
    openFollowupModal = (result) => {
        console.log(result);
        Store.updateStore('followup_task', result.result.task);
        this.setState({showModal: 'view_followup_modal',ready: true, isLoadedIcon: false});
    }

    render()
    {
        let contracts = Store.getStoreData('contacts');
        let giftTypeList = [];
        if('gift_types' in Store.getStoreData('module_config')){
            giftTypeList = Store.getStoreData('module_config').gift_types;
        }

        let task_id = this.props.taskId;
        if(!this.state.ready) {
            return <div><CSLLoader style={{position: 'absolute'}}/></div>
        }
        if(task_id > 0) {
            return(<div>
                {
                (() => {
                    if (this.state.showModal !== null) {
                        switch(this.state.showModal) {
                            case 'teamAskGiftsModal' : return <TeamAskGiftsModal closeModal={this.closeModal} />; break;
                            case 'view_followup_modal' : return <TeamFollowupModal closeModal={this.closeModal} />; break;
                            case 'teamApprovalGiftsModal' : return <div style={{position:'absolute', left:'2%', top:'50px', width:'100%', height:'600px'}}><InactiveOverlay /><TeamApprovalGiftsModal closeModal={this.closeModal} /></div>; break;
                        }
                    }
                })()
                }
            </div>)
        }
        return (
            <div>
                {
                    (() => {
                        if(this.state.isLoadedIcon){
                            return <div><CSLLoader style={{position: 'absolute'}}/></div>
                        }
                    })()
                }
                <div style={{boxSizing: "border-box", padding: "15px 10px 0px 10px"}}><AdvancedFilter contacts={Store.getStoreData('contacts')} gifttypelist={giftTypeList} giftstasklist={this.state.giftsTaskListFilter} filterSubmitValue={this.filterSubmit}/></div>

                <OverviewInfoHeader>
                    <div style={{float: "left", color: "#323232", fontWeight: "600"}}>Gifts & Hospitality Register</div>
                    <div style={{clear: "both"}}></div>
                </OverviewInfoHeader>
                <OverviewInfoBody>
                    <div  style={{position: 'relative'}}>
                    {
                        (() => {
                                if(Store.getStoreData('myinitiatedtasks') === null) {
                                return <CSLbucketloader style={{position: 'absolute'}} />
                                }
                        })()
                    }
                    <div style={{clear: "both", height: '3px'}}></div>
                    <CSLTable add={false} processData={this.processMygiftsValue} headerText={''} tableRows={10} refreshCallback={this.refreshCallback} />
                    </div>
                    <div style={{float: "left", color: "#0DB0AC", fontWeight: "600", fontStyle: "italic",marginTop: "28px"}}>{Store.getStoreData('myinitiatedtasks') === null ? 0 : this.state.giftsTaskList.length} Gifts Listed</div>
                    <div style={{float: "right"}}>
                    {
                        (() => {
                            let gifttaskall = Store.getStoreData('myinitiatedtasks') === null ? 0 : this.state.giftsTaskList.length;
                            if(gifttaskall !== 0){
                                return(<ExportButton onClick={this.exportToExcel}>Export</ExportButton>)
                            }
                        })()
                    }
                    </div>
                    <div style={{clear: "both"}}></div>
                </OverviewInfoBody>
                {
                    (() => {
                        let folluptaskAll = Store.getStoreData('followup_tasks') === null ? 0 : Store.getStoreData('followup_tasks').length;
                        if(folluptaskAll !== 0){
                            return(
                                <div>
                                    <OverviewInfoHeader>
                                        <div style={{float: "left", color: "#323232", fontWeight: "600"}}>My Followup Task</div>
                                        <div style={{clear: "both"}}></div>
                                    </OverviewInfoHeader>
                                    <OverviewInfoBody>
                                    <div  style={{position: 'relative'}}>
                                        {
                                            (() => {
                                                    if(Store.getStoreData('followup_tasks') === null) {
                                                    return <CSLbucketloader style={{position: 'absolute'}} />
                                                    }
                                            })()
                                        }
                                        <div style={{clear: "both", height: '3px'}}></div>
                                        <CSLTable add={false} processData={this.processMyfollowupValue} headerText={''} tableRows="5" refreshCallback={this.refreshCallback} />
                                        </div>
                                    </OverviewInfoBody>
                                </div>
                            )
                        }
                    })()
                }
                {
                (() => {
                    if (this.state.showModal !== null) {
                        switch(this.state.showModal) {
                            case 'teamAskGiftsModal' : return <div style={{position:'absolute', left:'2%', top:'50px', width:'100%', height:'600px'}}><InactiveOverlay /><TeamAskGiftsModal closeModal={this.closeModal} /></div>; break;
                            case 'teamApprovalGiftsModal' : return <div style={{position:'absolute', left:'2%', top:'50px', width:'100%', height:'600px'}}><InactiveOverlay /><TeamApprovalGiftsModal closeModal={this.closeModal} /></div>; break;
                            case 'view_followup_modal' : return <TeamFollowupModal closeModal={this.closeModal} />; break;
                        }
                    }
                })()
                }
                <AlertBox alertParam = {this.state.alert_param}/>
            </div>
        );
    }
}
export default GiftsList;
